import Warning from '@mui/icons-material/Warning';
import { Stack, Typography } from '@mui/material';
import { COMMON_STRING } from '@/constants/dictionary';

export const NotImplemented = () => {
  return (
    <Stack
      flexGrow={1}
      fontSize='3rem'
      alignItems='center'
      justifyContent='center'
      textAlign='center'
    >
      <Warning fontSize='inherit' />
      <Typography fontSize='inherit'>
        {COMMON_STRING.NOT_IMPLEMENTED_YET}
      </Typography>
    </Stack>
  );
};
